import React from 'react';
import { ConsoleErrorReporter, ErrorReporter } from '../../errorHandling/ErrorReporter';

export const ErrorReporterContext = React.createContext<ErrorReporter>(new ConsoleErrorReporter());

export const useErrorReporter = () => React.useContext(ErrorReporterContext);
